import axios from 'axios'
import router from '@/router';
import qs from 'qs';

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl
        this.queue = {}
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            headers: {
                //
            }
        }
        return config
    }
    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            this.queue[url] = true;
            let data = config.data;

            let params = {};
            for (var key in config.data) {
                params[key] = data[key];
            }
            config.data = qs.stringify(params, {arrayFormat: 'brackets'});

            return config
        }, error => {
            return Promise.reject(error)
        })
        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url)
            const {
                data,
                status
            } = res
            if (res.data.code === 998) {
                //无权限
                router.push({
                    path: '/jurisdiction'
                });
            } else if (res.data.code === 999) {
                sessionStorage.removeItem("U_TOKEN")
                let redirectPath = router.currentRoute.fullPath
                sessionStorage.setItem("redirectPath", redirectPath)
                //未登录
                setTimeout(() => {
                    router.push({
                        path: '/admin/login'
                    }); 
                }, 300);
            } else if (res.data.code === 888) {
                //无权限
                router.push({
                    path: '/dealer/Fjurisdiction'
                });
            } else if (res.data.code === 889) {
                //未登录
                sessionStorage.removeItem("U_TOKEN")
                localStorage.removeItem("fActMenu")
                let MOBILE_LOGIN = localStorage.getItem("MOBILE_LOGIN");
                if(MOBILE_LOGIN != null && MOBILE_LOGIN!=undefined && MOBILE_LOGIN == "1"){
                    setTimeout(() => {
                        router.push({
                            path: '/m/login'
                        }); 
                    }, 300);
                }else{
                    setTimeout(() => {
                        router.push({
                            path: '/login'
                        }); 
                    }, 300);
                }
            }
            return data
        }, error => {
            this.destroy(url)
            return Promise.reject(error)
        })
    }
    request(options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}

export default HttpRequest
